import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdSearch } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';


import cln1 from '../assets/services/ME/1.jpg';
import cln2 from '../assets/services/ME/2.jpg';
import cln3 from '../assets/services/ME/3.jpg';
import cln4 from '../assets/services/ME/4.jpg';
import cln5 from '../assets/services/ME/5.jpg';
import cln6 from '../assets/services/ME/6.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
											}}
										>
											Monitoring and Evaluation (M&E)
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">

								<HorizontalImageStrip
									images={[cln1, cln2, cln3, cln4]}
								/>

							</div>

							<div className="col-md-12 mt-3">
								<h5>
									Kobe Konsult provides monitoring and evaluation services that measure results and improve the performance of projects and organisations. <br/><br/>
									We apply results-based monitoring and evaluation tools, including log-frame analysis and a ten-point evaluation model. <br/>
									Our team conducts performance reviews, quality assurance assessments, mid-term evaluations, and end-line evaluations. 
								</h5>
							</div>

							<div className="col-md-12">
								<h2 className="fw-bold text-dark text-center mb-4">What We Do</h2>
								<p className="text-muted text-center mb-5" style={{ fontSize: '1.1rem' }}>
									We design and implement robust monitoring & evaluation (M&E) systems that turn data into actionable insight—ensuring accountability, learning, and impact.
								</p>

								<div className="row g-4">
									{/* Activities */}
									<div className="col-md-6">
										<div className="p-4 bg-light rounded-3 h-100">
											<h5 className="fw-bold text-primary mb-3">Activities</h5>
											<ul className="list-unstyled">
											<li className="mb-2 d-flex align-items-start">
												<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Develop M&E frameworks</span>
											</li>
											<li className="mb-2 d-flex align-items-start">
												<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Conduct baseline, midline, and endline studies</span>
											</li>
											<li className="mb-2 d-flex align-items-start">
												<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Review project performance and outcomes</span>
											</li>
											<li className="mb-2 d-flex align-items-start">
												<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Build internal M&E systems for organisations</span>
											</li>
											<li className="d-flex align-items-start">
												<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Deliver training on M&E tools and methods</span>
											</li>
											</ul>
										</div>
										</div>

										{/* Outputs / Deliverables */}
										<div className="col-md-6">
										<div className="p-4 bg-light rounded-3 h-100">
											<h5 className="fw-bold text-success mb-3">Deliverables</h5>
											<ul className="list-unstyled">
											<li className="mb-2 d-flex align-items-start">
												<span className="me-2 text-success" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>M&E plans</span>
											</li>
											<li className="mb-2 d-flex align-items-start">
												<span className="me-2 text-success" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Data collection tools</span>
											</li>
											<li className="mb-2 d-flex align-items-start">
												<span className="me-2 text-success" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Evaluation reports</span>
											</li>
											<li className="d-flex align-items-start">
												<span className="me-2 text-success" style={{ marginTop: '0.25rem' }}>✓</span>
												<span>Performance dashboards</span>
											</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}